module.exports = __webpack_public_path__ + "static/media/icon-footer-bottom.53c41483.png";